// client/src/components/payment/UnifiedCheckout.jsx
//
// Provider-agnostic checkout wrapper. Callers receive `provider`,
// `clientSecret`, and `sdkConfig` from a /purchase-intent response and
// hand them straight to this component without caring which payment
// platform is in use.
//
// onSuccess receives:
//   { providerPaymentId }  for Stripe (PaymentIntent id)
//   { sourceToken }        for Square (nonce — server must charge it)
//
// The caller then POSTs whichever is present to /purchase-confirm.

import React, { useState } from 'react';
import StripeCheckoutSection from './checkout/StripeCheckoutSection';
import SquareCheckoutSection from './checkout/SquareCheckoutSection';

const submitButtonStyle = (busy) => ({
  marginTop: 16,
  width: '100%',
  padding: '12px 16px',
  backgroundColor: '#ff6800',
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  fontSize: 16,
  fontWeight: 600,
  cursor: busy ? 'not-allowed' : 'pointer',
  opacity: busy ? 0.6 : 1,
});

export default function UnifiedCheckout({
  provider,
  clientSecret,
  sdkConfig,
  amountLabel,
  onSuccess,
  onError,
  onCancel,
}) {
  const [busy, setBusy] = useState(false);

  const handleError = (msg) => {
    setBusy(false);
    if (onError) onError(msg);
  };

  let section = null;
  if (provider === 'stripe') {
    section = (
      <StripeCheckoutSection
        clientSecret={clientSecret}
        amountLabel={amountLabel}
        onSuccess={onSuccess}
        onError={handleError}
        busy={busy}
        setBusy={setBusy}
        submitButtonStyle={submitButtonStyle}
      />
    );
  } else if (provider === 'square') {
    section = (
      <SquareCheckoutSection
        sdkConfig={sdkConfig}
        amountLabel={amountLabel}
        onSuccess={onSuccess}
        onError={handleError}
        busy={busy}
        setBusy={setBusy}
        submitButtonStyle={submitButtonStyle}
      />
    );
  } else {
    section = (
      <div style={{ color: '#dc2626' }}>
        Unsupported payment provider: <code>{String(provider)}</code>
      </div>
    );
  }

  return (
    <div>
      {section}
      {onCancel && (
        <button
          type="button"
          onClick={onCancel}
          disabled={busy}
          style={{
            marginTop: 12,
            width: '100%',
            padding: '10px 16px',
            backgroundColor: 'transparent',
            color: '#aaa',
            border: '1px solid #444',
            borderRadius: 6,
            fontSize: 14,
            cursor: busy ? 'not-allowed' : 'pointer',
          }}
        >
          Cancel
        </button>
      )}
    </div>
  );
}
